import React from "react";
import AboutMeComp from "../component/about/AboutMeComponent";
import HomePageLayout from "../component/homePageLayout/HomePageLayout";

const AboutMe = () => {
  return (
    <HomePageLayout>
      <AboutMeComp />
    </HomePageLayout>
  );
};

export default AboutMe;
